import { Inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { PlatformType } from '../types/muni-environment';
import { URLService } from './url.service';

@Injectable()
export class CustomContextMenuService {
  private readonly platform: PlatformType;
  constructor(
    private readonly urlService: URLService,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.platform =
      (config.params.platform as PlatformType) || PlatformType.polaris;
  }

  public getCustomContextMenu(urlTree: UrlTree): any[] {
    const url = this.urlService.getSerializedUrl(urlTree);

    // Make sure that the URL is under the same domain.
    if (!url.startsWith(window.location.origin)) {
      // Make sure the url has https and is not http
      console.error('Blocked attempt to open an untrusted URL:', url);
      return [];
    }

    const customItems = [
      {
        name: 'Open in new tab',
        action: this.openNewTabWithStorage.bind(this, url, true)
      },
      {
        name: 'Open in new window',
        action: this.openNewTabWithStorage.bind(this, url, false)
      }
    ];

    return [...customItems, 'separator'];
  }
  public openNewTabWithStorage(url: string, isNewTab: boolean): void {
    // Open a new tab
    const newTab = isNewTab
      ? window.open(url, '_blank')
      : window.open(url, '_blank', 'toolbar=yes');

    const sessionKey = this.getSessionKey();

    if (!sessionKey) {
      return;
    }

    const sessionVal = sessionStorage.getItem(sessionKey);
    const sessionStorageData = {
      [sessionKey]: sessionVal
    };

    if (newTab) {
      newTab.onload = () => {
        // Wait for the new tab to load and then send the data
        newTab.postMessage(
          {
            sessionStorageData
          },
          window.location.origin
        );
      };
    }
  }

  // extract session key from session storage for sellside and buyside
  public getSessionKey(): string | null {
    if (this.platform === PlatformType.polaris) {
      return Object.keys(sessionStorage).find((key) =>
        key.startsWith('oidc.user:')
      );
    } else if (this.platform === PlatformType.buyside) {
      return Object.keys(sessionStorage).find((key) =>
        key.startsWith('bsp-okta-auth-options')
      );
    } else {
      return null;
    }
  }
}
